import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { canCreateMerger } from "./permissions";
import { useRoles } from "./useRoles";
import { MERGERS_PATH } from "../utils/entityPaths";

type Props = {
  children: ReactNode;
};

export const RequireCreateMerger = ({ children }: Props) => {
  const roles = useRoles();

  if (!canCreateMerger(roles)) {
    return <Navigate to={MERGERS_PATH} replace />;
  }

  return children;
};
